/** Wraps Google Maps OverlayView to convert LatLng ↔ map container pixel coordinates. */
export class DispatchMapProjection {
  private overlay: google.maps.OverlayView | null = null;
  private map: google.maps.Map | null = null;

  attach(map: google.maps.Map): void {
    this.detach();
    this.map = map;
    this.overlay = new google.maps.OverlayView();
    this.overlay.onAdd = () => {};
    this.overlay.draw = () => {};
    this.overlay.setMap(map);
  }

  detach(): void {
    if (this.overlay) {
      this.overlay.setMap(null);
      this.overlay = null;
    }
    this.map = null;
  }

  hasProjection(): boolean {
    return !!this.overlay?.getProjection();
  }

  /**
   * Container-Pixel (nicht Div-Pixel) – entspricht map.getDiv() + Mauskoordinaten.
   * Div-Pixel kann je nach Zoom/Pane intern versetzt sein.
   */
  latLngToPixel(lat: number, lng: number): { x: number; y: number } | null {
    const projection = this.overlay?.getProjection();
    if (!projection) {
      return null;
    }
    const point = projection.fromLatLngToContainerPixel(new google.maps.LatLng(lat, lng));
    if (!point) {
      return null;
    }
    return { x: point.x, y: point.y };
  }

  pixelToLatLng(x: number, y: number): { lat: number; lng: number } | null {
    const projection = this.overlay?.getProjection();
    if (!projection) {
      return null;
    }
    const latLng = projection.fromContainerPixelToLatLng(new google.maps.Point(x, y));
    if (!latLng) {
      return null;
    }
    return { lat: latLng.lat(), lng: latLng.lng() };
  }
}
